// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:IoSKLE */\n.NxYaJ{border:1px solid var(--audio-form-default);border-radius:var(--audio-radius-1);padding:var(--audio-spacing-16)}.gZ3Cn{align-items:center;display:flex;gap:var(--audio-spacing-8);margin-bottom:var(--audio-spacing-8)}.KVQ3Y{color:var(--audio-content-primary);font-size:var(--audio-font-size-14);font-weight:600;margin:0}.-zEIx{color:var(--audio-content-secondary);font-size:var(--audio-font-size-12);margin:0}.mtnYz{color:var(--audio-action-link-default);font-size:var(--audio-font-size-12);text-transform:uppercase}.mtnYz:hover{color:var(--audio-action-link-hovered)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"license": "NxYaJ",
	"header": "gZ3Cn",
	"title": "KVQ3Y",
	"description": "-zEIx",
	"link": "mtnYz"
};
export default ___CSS_LOADER_EXPORT___;
